import type { FC } from 'react';
import { useMemo, useState } from 'react';
import { defaultLogoSrc, productLogoAlt } from 'src/config/projectConfig';
import useAuth from 'src/hooks/useAuth';
import { getWhiteLabelOrganization } from 'src/utils/whiteLabel';

interface LogoProps {
  height?: number | string;
  width?: number | string;
  src?: string;
}

const Logo: FC<LogoProps> = ({ width, height, src }: LogoProps) => {
  const { user } = useAuth();
  const whiteLabel = getWhiteLabelOrganization();
  const [hasError, setHasError] = useState(false);
  const organizationLogo = user?.organization?.logo || whiteLabel?.logo;
  const validOrganizationLogo =
    typeof organizationLogo === 'string' &&
    organizationLogo.trim() &&
    organizationLogo !== 'null' &&
    organizationLogo !== 'undefined'
      ? organizationLogo
      : '';

  const logoSrc = useMemo(() => {
    if (hasError) {
      return defaultLogoSrc;
    }
    return src || validOrganizationLogo || defaultLogoSrc;
  }, [hasError, src, validOrganizationLogo]);

  return (
    <img
      key={logoSrc}
      width={width}
      height={height}
      style={{ objectFit: 'contain', maxHeight: '110px' }}
      src={logoSrc}
      onError={() => setHasError(true)}
      alt={productLogoAlt}
    />
  );
};

export default Logo;
